//Default motions for all motion components
export const motions = {
  pTitle:{
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    viewport: { once: true },
    transition: { duration: 4 }
  }
}